import { render, staticRenderFns } from "./TopicBoardComment.vue?vue&type=template&id=2cc32ad2&"
import script from "./TopicBoardComment.vue?vue&type=script&lang=js&"
export * from "./TopicBoardComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports